/**
 * @file Date related helper functions.
 */

import moment from 'moment';

/**
 * Parse and format a date.
 *
 * @param {string} date The input date to format.
 * @returns {string} The formatted date.
 */
const formatDate = date => {
  if (!date) {
    return '';
  }

  return moment(date).format('MM/DD/YY h:mmA');
};

/**
 * Format two dates into a literal date range.
 *
 * @param {string} startDate The earlier date to format.
 * @param {string} endDate The later date to format.
 * @returns {string} The formatted date range.
 */
const formatDateRangeString = (startDate, endDate) => {
  const DATE_FORMAT = 'MMM D';
  if (startDate && endDate) {
    return `${moment(startDate).format(DATE_FORMAT)} - ${moment(endDate).format(
      DATE_FORMAT,
    )}`;
  }
  return startDate ? moment(startDate).format(DATE_FORMAT) : undefined;
};

const getDateWithoutTime = (date = new Date()) => {
  date.setHours(0, 0, 0, 0);
  return date;
};

export { formatDate, formatDateRangeString, getDateWithoutTime };
